import { useViewportSize } from "@mantine/hooks";
import { useEffect } from "react";
import { useExpertNoteStore } from "../notepadStore";

const refToCoordinates = (ref: React.RefObject<HTMLElement | null>) => {
    if (!ref.current) return null;
    const rect = ref.current.getBoundingClientRect();
    const coordinates = { x1: rect.x, y1: rect.y, x2: rect.x + rect.width, y2: rect.y + rect.height };
    return coordinates;
};

export const useSetDraggableBounds = (ref: React.RefObject<HTMLElement | null>) => {
    const { height, width } = useViewportSize();

    // biome-ignore lint/correctness/useExhaustiveDependencies: fix later
    useEffect(() => {
        const coordinates = refToCoordinates(ref);
        if (coordinates === null) return;

        useExpertNoteStore.getState().setDraggableBounds(coordinates);
    }, [ref, height, width]);

    return null;
};
